<template>
  <div
    class="flex relative items-center text-white bg-primary flex-none h-14 font-medium"
  >
    <!-- 關閉按鈕 -->
    <button
      class="flex flex-none items-center gap-1 whitespace-nowrap p-4"
      aria-label="返回"
      @click="$emit('close')"
    >
      <XIcon class="h-5 w-5" />
      <span class="text-sm font-medium">返回</span>
    </button>

    <!-- title -->
    <div class="min-w-0 flex-grow truncate text-center" v-text="title" />

    <!-- 分享按鈕 -->
    <button
      v-if="sharable"
      class="flex flex-none items-center gap-1 whitespace-nowrap p-4"
      aria-label="分享商品"
      type="button"
      @click="$emit('share')"
    >
      <ShareIcon class="h-5 w-5" />
      <span class="text-sm font-medium">分享</span>
    </button>
  </div>
</template>

<script>
import { XIcon, ShareIcon } from "@vue-hero-icons/outline";
export default {
  components: { XIcon, ShareIcon },
  props: {
    title: {
      type: String,
      required: true,
    },
    sharable: Boolean,
  },
};
</script>

<style lang="scss" scoped></style>
